/**
 * 🎯 ADMIN VERIFICATION DEMO PAGE
 * Standalone demo page for testing the admin verification system
 * Access directly via /verification/demo
 */

import React from 'react';
import {
  Box,
  Typography,
  Alert,
  Paper
} from '@mui/material';
import AdminVerificationDashboard from './AdminVerificationDashboard';

const AdminVerificationDemo: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Alert severity="info" sx={{ mb: 3 }}>
        <Typography variant="h6" component="div" gutterBottom>
          🎯 Admin Verification System Demo
        </Typography>
        <Typography variant="body2">
          This is the new admin verification system with mock data. 
          Since your backend endpoints aren't connected yet, you'll see realistic demo data.
          When your backend is ready, this will automatically switch to real data.
        </Typography>
      </Alert>
      
      <Paper elevation={2}>
        <AdminVerificationDashboard />
      </Paper>
    </Box>
  );
};

export default AdminVerificationDemo;